<div
  class="call"
  matTooltipClass="whitespace-pre-line"
  data-test-id="interview-period-calendar-call"
  [class.compact]="isCompact()"
  [matTooltip]="tooltip()"
>
  <a
    class="details flex flex-col"
    target="_blank"
    rel="noopener"
    data-test-id="interview-period-calendar-call-link"
    [style.top.px]="focusTop()"
    [style.height.px]="focusHeight()"
    [routerLink]="['/connect', publicDisplayId]"
    [queryParams]="{ expertId: current().item.expertId }"
  >
    @if (showName()) {
      <span class="name" data-test-id="interview-period-calendar-call-name">{{
        current().item.expertName
      }}</span>
    }
    @if (showTime()) {
      <span class="time" data-test-id="interview-period-calendar-call-time">{{
        time()
      }}</span>
    }
  </a>
  @if (hasMultiple()) {
    <div
      class="call-stepper flex flex-row items-center"
      data-test-id="interview-period-calendar-call-stepper"
      [class.on-group]="!isStepperOnCall()"
    >
      <button
        type="button"
        class="step flex"
        aria-label="Previous call"
        data-test-id="interview-period-calendar-call-previous"
        (click)="previous()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="count" data-test-id="interview-period-calendar-call-count">{{
        count()
      }}</span>
      <button
        type="button"
        class="step flex"
        aria-label="Next call"
        data-test-id="interview-period-calendar-call-next"
        (click)="next()"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  }
</div>
